function cov_h2epd2r2() {
  var path = "/app/src/utils/get-price-split-of.ts";
  var hash = "e47a8cd7f39c8142169e4f15d6cc5833ef6db26f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-price-split-of.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 8,
          column: 53
        }
      },
      "1": {
        start: {
          line: 8,
          column: 5
        },
        end: {
          line: 8,
          column: 53
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 4,
            column: 31
          },
          end: {
            line: 4,
            column: 32
          }
        },
        loc: {
          start: {
            line: 8,
            column: 5
          },
          end: {
            line: 8,
            column: 53
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 7,
            column: 16
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 15
          },
          end: {
            line: 7,
            column: 16
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e47a8cd7f39c8142169e4f15d6cc5833ef6db26f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_h2epd2r2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_h2epd2r2();
import { getFormattedAmount } from 'src/utils/get-formatted-amount';
cov_h2epd2r2().s[0]++;
export var getPriceSplitOf = function getPriceSplitOf(price, currency) {
  var splitCount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_h2epd2r2().b[0][0]++, 4);
  cov_h2epd2r2().f[0]++;
  cov_h2epd2r2().s[1]++;
  return getFormattedAmount(price / splitCount, currency);
};